module.exports = __webpack_public_path__ + "img/bg-artamart.9e06ab0c.jpg";